"use strict";

export function deepClone(target) {
  let result;
  if (typeof target === "object") {
    if (Array.isArray(target)) {
      result = [];
      for (let i in target) {
        result.push(deepClone(target[i]));
      }
    } else if (target === null) {
      result = null;
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
  } else {
    result = target;
  }
  return result;
}

export function groupBy(array, length) {
  let index = 0;
  let newArray = [];
  while (index < array.length) {
    newArray.push(array.slice(index, (index += length)));
  }
  return newArray;
}

export function sortBy(array, sortKey, order) {
  const reverse = order === "descending" ? -1 : 1;
  const getValueByPath = function (object, prop) {
    prop = prop || "";
    const paths = prop.split(".");
    let current = object;
    let result = null;
    for (let i = 0, j = paths.length; i < j; i++) {
      const path = paths[i];
      if (!current) break;

      if (i === j - 1) {
        result = current[path];
        break;
      }
      current = current[path];
    }
    return result;
  };

  const compare = function (a, b) {
    for (let i = 0, len = a.key.length; i < len; i++) {
      if (a.key[i] < b.key[i]) {
        return -1;
      }
      if (a.key[i] > b.key[i]) {
        return 1;
      }
    }
    return 0;
  };

  return array
    .map(function (value, index) {
      let key = getValueByPath(value, sortKey);
      return {
        value: value,
        index: index,
        key: key ? key : ""
      };
    })
    .sort(function (a, b) {
      let order = compare(a, b);
      if (!order) {
        order = a.index - b.index;
      }
      return order * reverse;
    })
    .map(item => item.value);
}

export function saveAs(blob, fileName) {
  fileName = fileName || `${Date.now()}.xlsx`;
  // 兼容ie
  if ("msSaveOrOpenBlob" in navigator) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    let url;
    if (typeof blob == "object" && blob instanceof Blob) {
      url = URL.createObjectURL(blob);
    }
    let aLink = document.createElement("a");
    aLink.href = url;
    aLink.download = fileName
    aLink.click();
  }
}

function getFileType (filename) {
  const types = {
    ".pdf": "pdf", ".doc": "doc", ".docx": "doc", ".ppt": "ppt", ".pptx": "ppt"
  };
  const index = filename.lastIndexOf(".");
  const suffix = filename.substring(index).toLowerCase();
  return types[suffix];
}

export function filesHandler (files){
  return files.map(({originalName, dUrl, code}) => {
    const type = getFileType(originalName);
    const previewUrl = `/online-preview/${code}`;
    // const previewUrl = type === "pdf" ? pUrl : `/online-preview/${code}`;
    return {
      originalName, url: dUrl, previewUrl, type
    }
  });
}
